import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import Header from '@components/common/Header/Header';
import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';

import useTranslation from '@hooks/useTranslation';

import EquipmentBlock from './components/EquipmentsBlock/EquipmentsBlock';
import { selectManageEquipmentSearch, useManageEquipmentActions } from './store/useManageEquipmentStore';

const ManageEquipment = () => {
  const { t } = useTranslation();
  const { trackPageView } = useMatomo();

  const { setEquipmentSearch } = useManageEquipmentActions();

  const equipmentSearch = selectManageEquipmentSearch();

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <>
      <Header
        title={t('Manage Equipment')}
        showLogo={true}
        showFacilitySelect={true}
        extraInfo={
          <FilterSearch
            value={equipmentSearch}
            onChange={setEquipmentSearch}
            placeholder={t('Start to type...')}
            variant="header-search"
          />
        }
      />
      <EquipmentBlock />
    </>
  );
};

export default ManageEquipment;
